import { AlertTriangle } from 'lucide-react';
import { cn } from '@/utils/cn';
import { formatFlagEntities } from '@/utils/automationFlags';
import type { AutomationFlag } from '@/types/automationFlags';

export function FlagCallout({ flags }: { flags: AutomationFlag[] }) {
  if (flags.length === 0) return null;
  return (
    <div className="space-y-2">
      {flags.map((flag, index) => {
        const isError = flag.severity === 'error';
        const entities = formatFlagEntities(flag);
        const related = flag.related.map((item) => item.label).filter(Boolean);
        return (
          <div
            key={`${flag.code}:${flag.severity}:${index}`}
            className={cn(
              'flex items-start gap-2 rounded-xl border px-3 py-2 text-sm',
              isError
                ? 'border-error/20 bg-error-subtle text-error-ink'
                : 'border-warning/20 bg-warning-subtle text-warning-ink'
            )}
          >
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
            <div className="min-w-0 space-y-1">
              <p className="font-medium">{flag.title}</p>
              <p>{flag.message}</p>
              {related.length > 0 ? (
                <p className="text-xs opacity-90">Also in: {related.join(', ')}</p>
              ) : null}
              {entities ? <p className="text-xs opacity-90">{entities}</p> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
